// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zm_k","delete":"styles_delete__3iNJL","update":"styles_update__q1WM9","add":"styles_add__m-pkz"};